import {applyMiddleware, createStore, compose} from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers';

const middleware = applyMiddleware(thunk);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (state) => createStore(reducer, state, composeEnhancers(middleware));